import React from "react";

/**
 * Renders Service + FAQPage JSON-LD for a specific city landing page.
 * This is IN ADDITION to the global LocalBusinessSchema in App.js —
 * it gives Google a page-specific entity to match against the
 * "website development company in <city>" query.
 */
export default function CityPageSchema({ city, slug, faqs }) {
  const url = `https://almondsoftwares.in/${slug}`;

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Website Development",
    provider: {
      "@type": "ProfessionalService",
      "@id": "https://almondsoftwares.in/#organization",
      name: "Almond Software"
    },
    areaServed: {
      "@type": "City",
      name: city
    },
    url,
    description: `Custom website, ecommerce and software development services for businesses in ${city}, by Almond Software.`
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a
      }
    }))
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://almondsoftwares.in/"
      },
      {
        "@type": "ListItem",
        position: 2,
        name: `Website Development in ${city}`,
        item: url
      }
    ]
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
}